import {Directive, ElementRef, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {PermissionToolkitService} from '../services/permission-toolkit.service';

@Directive({
  selector: '[piPrivilegeCheck]'
})
export class PrivilegeCheckDirective {
  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionToolkitService: PermissionToolkitService
  ) {
  }

  @Input() set piPrivilegeCheck(code: string) {
    const hasPermission = this.checkPermission(code);
    if (hasPermission) {
      // If condition is true add template to DOM
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      // Else remove template from DOM
      this.viewContainer.clear();
    }
  }

  checkPermission(code) {
    const canCreateView = this.permissionToolkitService.hasPagePermission(code);
    return canCreateView;
  }

}
